import React, { useState } from 'react'
import { Header } from '../wallet/header/header'
import { Footer } from '../Home/Footer'
import axios from '../utils/axios'
import useAuth from '../context/hook/useAuth'
//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'

import { Link,useNavigate } from 'react-router-dom';
import { MiniHeader } from '../Home/MiniHeader'

import site from "../utils/SiteSettings"

export const BuyToken = () => {

    const {user} = useAuth()

    const [pair, setPair] = useState()

    const [balance, setBalance] = useState(0)

    const [Fee, setFee] = useState([])

    const [val, setVal] = useState()

    const [isLoading, setIsLoading] = useState(false)

    const [receive, setReceive] = useState()

    const [final, setFinal] = useState()

    const [tokenFee, setTokenFee] = useState()

    const [hint, setHint] = useState()

    const navigate = useNavigate()

    const getBalance = async (e) => {
        
        setPair(e.target.value)
        try {
            await axios.put(`/particular/balance`,
                {
                    // id:'675819c6462acf37e7846b7a',
                    coin:e.target.value,
                    // id:auth.userId,
                    command: 'stop'
                },
                {
                    headers:{
                        "Content-Type": "application/json",
                        "Authorization":user
                    },
                    withCredentials:true,
                }
            ).then((res)=>{

                let data = JSON.parse(res.data)
                // console.log(data)
                setBalance(data.val)
                setFee(data.fee)
                setReceive('')
                setVal('')
            }).catch(err=>{
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
    }

    const Balance = async () => {
        
        // setPair(e.target.value)
        try {
            await axios.put(`/particular/balance`,
                {
                    // id:'675819c6462acf37e7846b7a',
                    coin:pair,
                    // id:auth.userId,
                    command: 'stop'
                },
                {
                    headers:{
                        "Content-Type": "application/json",
                        "Authorization":user
                    },
                    withCredentials:true,
                }
            ).then((res)=>{

                let data = JSON.parse(res.data)
                // console.log(data)
                setBalance(data.val)
                setFee(data.fee)
                setReceive('')
                setVal('')
            }).catch(err=>{
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
    }
    const calulationVal = async (e) => {
        
        try {
            setVal(e.target.value)
            let final = e.target.value * Fee.price
            let rec = final/Fee.tokenPrice
            // let tokFee = rec*(Fee.tokenFee/100)
            let tokFee = (Fee.tokenFee)
            console.log(tokFee)
            // console.log(rec)
            setReceive(rec)
            setTokenFee(tokFee)
            setFinal(rec-tokFee)
            setHint("Crypto")
            // console.log(rec,tokFee,rec-tokFee)
        } catch (error) {
            console.log(error)
        }
    }

    const calulationVal1 = async (balance) => {
        
        try {
            setVal(balance)
            let final = balance * Fee.price
            let rec = final/Fee.tokenPrice
            // let tokFee = rec*(Fee.tokenFee/100)
            let tokFee = (Fee.tokenFee)
            console.log(tokFee)
            // console.log(rec)
            setReceive(rec)
            setTokenFee(tokFee)
            setFinal(rec-tokFee)
            setHint("Crypto")
            // console.log(rec,tokFee,rec-tokFee)
        } catch (error) {
            console.log(error)
        }
    }

    const calulationRec = async (e) => {
        
        try {
            // console.log(e.target.value)
            setReceive(e.target.value)
            let tokFee = (Fee.tokenFee)
            // let tokFee = e.target.value*(Fee.tokenFee/100)
            let final = Fee.price1 * e.target.value
            let value =  (final / Fee.price )
            console.log(tokFee)
            // let final = Fee.price / e.target.value
            // let value = final / Fee.price
            setVal(value)
            setTokenFee(tokFee)
            setFinal(e.target.value-tokFee)
            setHint("Token")
            // console.log(final,value,tokFee,e.target.value-tokFee,e.target.value)
            // console.log(final,value,e.target.value)
        } catch (error) {
            console.log(error)
        }
    }
// console.log(site.site.siteName)
    const onSubmit = async (e) => {
        try {
            // eslint-disable-next-line
            if(pair == '') return toast.error(`Select a pair`,{position:'top-right'})
            // if(Otp === userOTP){
                // if(fees.data.minWitusdt <= val){
                if((Fee.minToken - 1) < receive){
                // if(receive >= Fee.minToken ){
                    if(balance >= val ){
                        setIsLoading(true)
                        await axios.post(
                            "/buy/token",
                            {
                                // id:auth.userId,
                                // id:'675819c6462acf37e7846b7a',
                                amount:final,
                                receiveToken:receive,
                                tokenFee,
                                val,
                                hint,
                                type:'buy',
                                typeOf:"Crypto",
                                asset:pair,
                            },{
                                headers:{
                                    "Content-Type": "application/json",
                                    "Authorization":user
                                },
                                withCredentials:true,
                            }
                        ).then(()=>{
                            setTimeout(()=>{
                                navigate('/wallet',{replace: true})
                            },1500)
                            setIsLoading(false)
                            Balance()
                            toast.success("Token bought successfully",{position:'top-right'})
                            // console.log("done")
                        }).catch((err)=>{
                            setIsLoading(false)
                            console.log(err)
                        })
                    }else{
                        toast.error(`Insufficient balance`,{position:'top-right'})
                    }
                }
                else{
                    // toast.error(`Min value is ${fees.data.minWitusdt}`,{position:'top-right'})
                    toast.error(`Min Buy is ${Fee.minToken} ${site?.site?.siteName}`,{position:'top-right'})
                    console.log(`Min Buy is ${Fee.minToken}`,"rec",receive,"test",Fee.minToken<= receive )
                }
            // }
            // else{
            //     toast.error("Please enter valid otp",{position:"top-right"})
            // }
        } catch (error) {
            console.log(error)
        }
    }
// console.log(val>0 && val != undefined && val != "" && val%1 != 0 ? val.length > 6 ? parseFloat(val).toFixed(6) : val : val )
// console.log(parseFloat(val).toFixed(6))
// console.log(val%1!=0)
  return (
    <div>

        <Header />

        {/* <!-- service section start --> */}
            <section className="feature-section pb-0">
                <div className="container pb-md-5 pb-0">
                    <div className="title-basic fs-sm">
                        {/* <!-- <h2 className="text-white">A Wide Range of
                            Functionality to Support Any Use Case</h2> --> */}
                    </div>
                    <ul className="tab-section mt-80">
                        <li><Link to={"/wallet"}>Wallet</Link></li>
                        <li className="active"><Link to={""}>Buy {site && site?.site?.siteName}</Link></li>
                        <li><Link to={"/deposit"}>Deposit</Link></li>
                        <li><Link to={"/withdrawal"}>Withdraw</Link></li>
                        <li><Link to={"/setting"}>Settings</Link></li>
                        <li><MiniHeader /></li>
                    </ul>
                    <div className="row g-xxl-5 g-4 justify-content-center">
                    <div className="col-lg-5">
                        <div className="buy-box">
                            <div className="buy-head">
                                <h3>Buy <span>{site?.site?.siteName}</span></h3>
                            </div>
                            <div className="deposit-area">
                                <form action="">
                                    
                                    <div className="form-group">
                                        <label htmlFor="exampleFormControlSelect1">Select Crypto</label>
                                        <select value={pair} onChange={e=>getBalance(e)} className="custom-select" required="">
                                            <option value="">Select Crypto</option>
                                            <option value="BNB">BNB</option>
                                            <option value="USDT">USDT</option>
                                            <option value="TRX">TRX</option>
                                            {/* <option value="ETH">ETH</option> */}
                                        </select>
                                        
                                    </div>
                                    <div className="">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">You Pay ({pair})</label>
                                        <input  value={val||""} onChange={e=>calulationVal(e)}  type="number" className="form-control" id="exampleFormControlInput1" placeholder=""/>
                                        {/* <input  value={(val>0 && val != undefined && val != "" && (val % 1 != 0) ? parseFloat(val).toFixed(6) : val)||""} onChange={e=>calulationVal(e)}  type="email" className="form-control" id="exampleFormControlInput1" placeholder=""/> */}
                                    </div>
                                    <div className="qtsYk set-avail">
                                        
                                    
                                        <div className="MhbUH"  onClick={()=>calulationVal1(balance&&balance)}>
                                        <dl>
                                            <dt className="lqZuR">
                                            </dt>
                                            <dd className="lqZuR">
                                            <span className="-m6DU el-tooltip__trigger el-tooltip__trigger">Total:</span>
                                            <strong style={{"margin": "0px 4px"}}>{ balance ? balance.toFixed(8) :  "--" } {pair === "TOKEN" ? site?.site?.siteName : pair}</strong>
                                            <svg fill="currentColor" style={{"width": "16px", height: "16px"}}>
                                                <use xlinkHref="#web-core-icon-transfer"></use>
                                            </svg>
                                            </dd>
                                        </dl>
                                        </div>
                                        </div>
                                    <div className="">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Total ({site?.site?.siteName})</label>
                                        <input value={receive||""} onChange={e=>calulationRec(e)} type="number" className="form-control" id="exampleFormControlInput1" placeholder=""/>
                                    </div>
            
                                    <div className="qtsYk set-avail">
                                        
                                    
                                        <div className="MhbUH">
                                        {/* <dl>
                                            <dt className="lqZuR">
                                            </dt>
                                            <dd className="lqZuR">
                                            <span className="-m6DU el-tooltip__trigger el-tooltip__trigger">Available:</span>
                                            <strong style={{"margin": "0px 4px"}}>{ balance ? balance.toFixed(8) :  "--" } {pair === "TOKEN" ? site?.site?.siteName : pair}</strong>
                                            <svg fill="currentColor" style={{"width": "16px", height: "16px"}}>
                                                <use xlinkHref="#web-core-icon-transfer"></use>
                                            </svg>
                                            </dd>
                                        </dl> */}
                                        <dl>
                                            <dt className="lqZuR">
                                            </dt>
                                            <dd className="lqZuR">
                                            {/* <span className="-m6DU el-tooltip__trigger el-tooltip__trigger">COINST to {pair ? pair : "Select Crypto"}</span> */}
                                            <strong style={{"margin": "0px 4px"}}> {Fee ? 1 : ""} {site?.site?.siteName} = {Fee.price ? ((Fee.price1*1)/Fee.price).toFixed(6):""} {pair} </strong>
                                            <svg fill="currentColor" style={{"width": "16px", height: "16px"}}>
                                                <use xlinkHref="#web-core-icon-transfer"></use>
                                            </svg>
                                            </dd>
                                        </dl>
                                        <dl>
                                            <dt className="lqZuR">
                                            </dt>
                                            <dd className="lqZuR">
                                            {/* <span style={{height: "16px",fontSize:"15px"}} > {receive >= Fee.minToken ? `` : `Min Buy should be ${Fee.minToken} ${site?.site?.siteName}` } </span> */}
                                            {/* <strong style={{"margin": "0px 4px"}}>{ balance ? balance :  "--" } {pair == "TOKEN" ? "COINST" : pair}</strong> */}
                                            <svg fill="currentColor" style={{"width": "16px", height: "16px"}}>
                                                <use xlinkHref="#web-core-icon-transfer"></use>
                                            </svg>
                                            </dd>
                                        </dl>
                                        {/* <!----> */}
                                        </div>
                                        <div className="_9truM">
                                            <dl>
                                                <dt>Fee</dt>
                                                <dd>
                                                <strong>{Fee.tokenFee != [] ? Fee.tokenFee  :  "--"} {site?.site?.siteName}</strong>
                                                </dd>
                                            </dl>
                                            <dl>
                                                <dt>{receive >= Fee.minToken && "To Receive"}</dt>
                                                <dd>
                                                <strong>{Number(receive) >= Number(Fee.minToken) ? final : `Min Buy should be ${Fee && Fee?.minToken} ${site?.site?.siteName}` }</strong>
                                                </dd>
                                            </dl>
                                            {/* <!----> */}
                                        </div>
                                        {
                                            isLoading ? (
                                                <>
                                                    <button disabled data-size="large" type="button" className="jRLsY SOUdU" style={{"width": "100%", marginTop: "24px"}}>
                                                        <span>
                                                            {/* <!----> */}
                                                            {/* BUY {site?.site?.siteName} */}
                                                            {/* <!----> */}
                                                            Transaction is Proccessing .....
                                                        </span>
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <button onClick={onSubmit} data-size="large" type="button" className="jRLsY SOUdU" style={{"width": "100%", marginTop: "24px"}}>
                                                        <span>
                                                            {/* <!----> */}
                                                            BUY {site?.site?.siteName}
                                                            {/* <!----> */}
                                                        </span>
                                                    </button>
                                                </>
                                            )
                                        }
                                    </div>
                                    
                                </form>
                            
                            </div>

                        </div>
                    </div>
                    </div>
                </div>
            </section>
            {/* <!-- service section end --> */}

            <Footer />

    </div>
  )
}
